//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MipLightbox from '@/components/clinicToast/mipLightbox'
import { hospitalGrid } from '@/model/appointment/hospitalListService'
import { store } from "@/observable/store"

export default {
    name: "applicable",
    data(){
        return {
          dataList:[]
        }
    },
    computed: {
        point(){
            return store.locaPoint
        }
    },
    components:{
      MipLightbox
    },
    props:{
      datailsInfo:{
        type:Object,
        default (){ return {} }
      },
      templateFlag:{
        type:String,
        default (){ return ""}
      }
    },
    created() {
       if(this.point){
            this.hostGrid()
        }else{
            this.hostCity()
        }
    },
    mounted() {
    },
    methods:{
       mapClick(e){
            let ponit = this.dataList[e]
            let hostPonit = {
                lat: ponit.latitude,
                lng: ponit.longitude
            }
            this.$refs.mipLightbox.showToast(hostPonit)
        },
        hostCity(){ // 城市请求
          this.dataList = [
                      {
                      code: "ed761211fc9f11e5b34f00163e0007e5",
                      name: "北京斯迈尔口腔门诊部（劲松店）",
                      address: "朝阳区东三环广渠路66号院甲9号楼1层101",
                      score: 5,
                      front_cover: "https://s.f.leya920.com/jck51/upload/photo_image/2016/04/07/17/8d8dc9eb6ee84cd68bdb52cdfaf8538d.jpg",
                      longitude: "116.469988",
                      latitude: "39.894690",
                      },
                      {
                      code: "b1c63c9eb29111e4afebf0def1afa7a1",
                      name: "上海乐雅口腔门诊部",
                      address: "浦东新区龙阳路2277号永达大厦10F",
                      score: 4,
                      front_cover: "https://s.f.leya920.com/jck51/upload/photo_image/2017/12/26/11/9a76d2376ca34b16b24e4b96d4572fa4.png",
                      longitude: "121.569790",
                      latitude: "31.211389"
                      },{
                      code: "4f88160baf3511e8867e00163e0007e5",
                      name: "正夫口腔（罗湖东门店）",
                      address: "罗湖区深南东路金城大厦3座首层3053",
                      score: 5,
                      front_cover: "https://s.f.leya920.com/jck51/upload/photo_image/2018/09/07/17/6a116dd464494b58899303927e4aeb83.png",
                      longitude: "114.128156",
                      latitude: "22.549556"}
          ]
        },
        hostGrid(){ //经纬度请求
            let parme = {
                "longitude": this.point.lng.toString(),
                "latitude": this.point.lat.toString(),
                'tmpl':this.templateFlag,
                // 'tmpl':'tk_irok',
                'page':'1'
            }
            hospitalGrid(parme).then((data) => {
                let list;
                if(data.next){
                    list = data.data
                    if(list.length>3){
                        this.dataList = list.splice(0,3)
                    }else{
                        if(list.length<1){
                            this.dataList = this.datailsInfo.hospital.hospital_list
                        }else{
                            this.dataList = list
                        }
                    }
                }else{
                    if(data.length>3){
                        this.dataList = data.splice(0,3)
                    }else{
                        if(data.length<1){
                            this.dataList = this.datailsInfo.hospital.hospital_list
                        }else{
                            this.dataList = data
                        }
                    }
                }
            }).catch((err) => {
                this.dataList = this.datailsInfo.hospital.hospital_list
            });
        },
        hostMap(){
            this.STATISTICS('click','sybao_ins_proinfo_clinicdetail_click')
        },
        hostList(){
            this.$refs.mipLightbox.showToast();
            this.STATISTICS('click','sybao_ins_proinfo_allclinic_click')

        },
    }
}
